import { createSlice } from "@reduxjs/toolkit";
import {
  hideNotificationThunk,
  sendAlertViaEmail,
  showNotificationThunk,
} from "./thunks";
import { NotificationSeverity } from "helpers/constants";
import {
  changePasswordThunk,
  checkLoggedUserThunk,
  logInThunk,
  logoutThunk,
  resetPasswordThunk,
} from "../auth/thunks";
import { StatusGenerator } from "../../utils/StatusGenerator";
import { IStoreStatuses, STATUS_ENUM } from "../../types/statuses";

interface IState {
  showAlert: boolean;
  message: string;
  severity: "success" | "error" | "info" | "warning" | undefined;
  statuses: IStoreStatuses;
}

const initialState: IState = {
  showAlert: false,
  message: "Heads up!",
  severity: NotificationSeverity.info,
  statuses: StatusGenerator.generateStatuses([
    logInThunk.typePrefix,
    logoutThunk.typePrefix,
    resetPasswordThunk.typePrefix,
    changePasswordThunk.typePrefix,
    checkLoggedUserThunk.typePrefix,
  ]),
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(showNotificationThunk.fulfilled, (state, { payload }) => {
        state.showAlert = true;
        state.message = payload.message;
        state.severity = payload.severity;
      })
      .addCase(hideNotificationThunk.fulfilled, (state, { payload }) => {
        state.showAlert = false;
      })
      .addCase(sendAlertViaEmail.pending, (state) => {
        state.statuses[sendAlertViaEmail.typePrefix] =
          StatusGenerator.setStatus(STATUS_ENUM.PENDING);
      })
      .addCase(sendAlertViaEmail.rejected, (state, { payload }) => {
        state.statuses[sendAlertViaEmail.typePrefix] =
          StatusGenerator.setStatus(STATUS_ENUM.REJECTED, payload as string);
      })
      .addCase(sendAlertViaEmail.fulfilled, (state) => {
        state.statuses[sendAlertViaEmail.typePrefix] =
          StatusGenerator.setStatus(STATUS_ENUM.FULFILLED);
      }),
});

export default alertSlice;
